import { postTrackingData } from "@/api/endpoints/track";
import { SOURCE } from "@/constants";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import useFilterParams from "@/hooks/useFilterParams";
import { useOrganization } from "@/hooks/useOrganization";
import { Button } from "@components/ui/button";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "@components/Dropdown";
import { i18n } from "@lingui/core";
import { ArrowUpDownIcon } from "lucide-react";

const SORT_OPTIONS = [
  {
    key: "date",
    value: "",
    label: L.MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_DATE,
  },
  {
    key: "reach",
    value: "reach",
    label: L.MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_REACH,
  },
  {
    key: "relevance",
    value: "relevance",
    label: L.MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_RELEVANCE,
  },
];

const SORT_OPTIONS_US_ONLY_ACCOUNTS = [
  ...SORT_OPTIONS,
  {
    key: "popularity",
    value: "popularity",
    label: L.MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_POPULARITY,
  },
];

const SORT_OPTIONS_AS_OPTIONS = SORT_OPTIONS.map(({ value, label }) => [
  value,
  label,
]);

const SORT_OPTIONS_US_ONLY_ACCOUNTS_AS_OPTIONS =
  SORT_OPTIONS_US_ONLY_ACCOUNTS.map(({ value, label }) => [value, label]);

const SortButton = () => {
  const [filters, setFilters] = useFilterParams();
  const { data: orgData } = useOrganization();
  const plan = orgData?.ok ? orgData.data.plan : null;
  const isUsOnlyOrganization =
    plan?.markets.length === 1 && plan?.markets[0] === "us";

  const { alert } = useMentionCards();

  const alertHasPodcastSource = alert?.sources.includes(SOURCE.PODCAST);

  // US-only organzations can also sort by popularity
  const sortOptions =
    isUsOnlyOrganization && alertHasPodcastSource
      ? SORT_OPTIONS_US_ONLY_ACCOUNTS_AS_OPTIONS
      : SORT_OPTIONS_AS_OPTIONS;

  const selectedOption =
    SORT_OPTIONS.find((SORT_OPTION) => SORT_OPTION.value === filters.sort_by) ||
    SORT_OPTIONS[0];

  return (
    <Dropdown>
      <div data-testid="filter-bar--sorting">
        <DropdownToggle asChild>
          <Button type="button" variant="ghost">
            {i18n._(selectedOption?.label || "")}
            <ArrowUpDownIcon />
          </Button>
        </DropdownToggle>
      </div>
      <DropdownMenu>
        {sortOptions.map(([value, label]) => (
          <DropdownItem
            key={value}
            data-testid={`sort-option-${value}`}
            onClick={() => {
              postTrackingData("Mentions sorted", { sort_by: value || "date" });
              setFilters({
                sort_by: value,
              });
            }}
          >
            {i18n._(label)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default SortButton;
